import { render, staticRenderFns } from "./FotoCatalogo.vue?vue&type=template&id=2baf2e1c&scoped=true&"
import script from "./FotoCatalogo.vue?vue&type=script&lang=js&"
export * from "./FotoCatalogo.vue?vue&type=script&lang=js&"
import style0 from "./FotoCatalogo.vue?vue&type=style&index=0&id=2baf2e1c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2baf2e1c",
  null
  
)

export default component.exports